import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Pick a file and run a preview call. Never commits. */
export default function ImportUploadCard({ title, description, accept, hint, onPreview, testid }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      await onPreview(file);
    } catch (err) {
      setError(err?.response?.data?.detail || err.message || "Preview failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid={`${testid}-card`}>
      <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
      <p className="mt-1 text-xs text-slate-500">{description}</p>
      {hint && <p className="mt-2 text-[11px] font-mono text-slate-400">{hint}</p>}
      <input ref={inputRef} type="file" accept={accept} onChange={handle} className="hidden"
             data-testid={`${testid}-input`} />
      <Button size="sm" variant="outline" className="mt-3" disabled={busy}
              onClick={() => inputRef.current?.click()} data-testid={`${testid}-btn`}>
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Upload className="h-4 w-4 mr-2" />}
        {busy ? "Reading file…" : "Choose file"}
      </Button>
      {error && <p className="mt-2 text-xs text-red-600" data-testid={`${testid}-error`}>{error}</p>}
    </div>
  );
}
